import { call, put, takeLatest } from 'redux-saga/effects';
import { GEO_EXEMPTION_EXCLUSION_REQUEST, GEO_TOP_FILTER_REQUEST, GET_TOTAL_TINS_REQUEST } from '../actions/actionTypes';
import {
  setRequestError,
  setRequestLoading,
  setRequestSuccess,
} from '../actions/common/common.actions';
import { exemptionKey } from '@src/CommonComponents/constant/constant';
import { geoExemptionAndExclusion, geoFilterResponseStateAndRegion } from '../services/exemptionAffordability/exemptionAffordability.service';
import { getTotalTinsData } from '../services/exemptionAffordability/exemptionAffordability.service';



const getExemptionMethod: any = (key: string) => {
  switch (key) {
    case exemptionKey.topGeoFilter:
      return geoFilterResponseStateAndRegion;
    case exemptionKey.exemptionAndExclusion:
      return geoExemptionAndExclusion;
      case exemptionKey.totalTins:
        return getTotalTinsData; // Using the same service as exemptionAndExclusion
    default:
      return geoFilterResponseStateAndRegion;
  }
};
export function* fetchExemptionData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    const clonedPayload = { ...payload }; // Clone the payload to avoid mutation
    const response = yield call(getExemptionMethod(key), clonedPayload);

    yield put(setRequestLoading(false, loadingKey));

    if (response?.status === false) {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  }
}
export function* exemptionSaga() {
  yield takeLatest(GEO_TOP_FILTER_REQUEST, fetchExemptionData);
  yield takeLatest(GEO_EXEMPTION_EXCLUSION_REQUEST, fetchExemptionData);
  yield takeLatest(GET_TOTAL_TINS_REQUEST, fetchExemptionData);
}

export default [exemptionSaga];
